export default "__VITE_ASSET__42ff4728__"